/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeMenuItemSpace } from "../../d-menu-item-space";
import { DThemeWhiteLayoutSpace } from "./d-theme-white-layout-space";

export class DThemeWhiteMenuItemSpace
	extends DThemeWhiteLayoutSpace
	implements DThemeMenuItemSpace {}
